import React, { useContext, useEffect, useRef, useState } from "react";
import axios from "../AxiosInstance";
import Header3 from "../components/Header3";
import moment from "moment";

import { ArrowLeft } from "react-bootstrap-icons"; // Assuming you're using Bootstrap Icons
import { Dropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import SocketContext from "../context/SocketContext";


const novmsg = [
  {
    id: 1,
    name: "Sally Rooney",
    message: "Ok see you there!",
    timeAgo: "4 days ago",
    details: [
      {
        text: "Nov XXXXX XXXX XXXXXX XXXXX XXXXXXX XXXXX      XXXXXX XXXXXX XXXXXX XXXXXXX   ",
        time: "3:15",
      },
    ],
  },
];

const ChatBox = () => {
  const socket = useContext(SocketContext);
  const userData = JSON.parse(localStorage.getItem("auth"));
  const [chats, setChats] = useState([]);
  const [messages, setMessages] = useState([]);
  const [selected, setSelected] = useState("");
  // Fetch all chats for the current user
  const fetchChats = async () => {
    try {
      const { data } = await axios.get(
        `/api/v1/chat/fetch/${userData?.user?._id}`
      );
      if (data.success) {
        setChats(data.chats);
      } else {
        console.error("Failed to fetch chats:", data.message);
      }
    } catch (error) {
      console.error("Error fetching chats:", error);
    }
  };

  // Fetch chats on component mount
  useEffect(() => {
    if (userData?.user?._id) {
      fetchChats();
    }
  }, [userData?.user?._id]);
  const [selectedUser, setSelectedUser] = useState();
  const [isMobileDetailView, setIsMobileDetailView] = useState(false); // State to manage mobile view

  // On component mount, check if a user is saved in localStorage
  useEffect(() => {
    const savedUser = localStorage.getItem("selectedUser");
    if (savedUser) {
      setSelectedUser(JSON.parse(savedUser));
      setIsMobileDetailView(true); // Show detail view on refresh if a user is selected
    }
  }, []);
  const fetchAllMessages = async (chatId) => {
    try {
      const { data } = await axios.get(`/api/v1/chat/messages/${chatId}?userId=${userData?.user?._id}`);
      console.log(data.success, "data");
      setMessages(data);
    } catch (error) {
      console.error("Error fetching messages:", error);
    }
  };

  const handleUserClick = (msg) => {
    setSelectedUser(msg);

    setIsMobileDetailView(true); // Show details view for mobile
    fetchAllMessages(msg._id); // Fetch messages for the selected user
  };

  const handleGoBack = () => {
    setIsMobileDetailView(false); // Go back to the list view
    setSelectedUser(null);
    localStorage.removeItem("selectedUser"); // Clear localStorage
  };
  const navigate = useNavigate();

  const [message, setMessage] = useState("");
  const textareaRef = useRef(null);

  const handleInputChange = (e) => {
    setMessage(e.target.value);
    autoResize();
  };

  const autoResize = () => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    textarea.style.height = "40px"; // Fixed initial height
    textarea.style.height = `${Math.min(textarea.scrollHeight, 150)}px`; // Expand up to 150px max
  };

  return (
    <>
      <div className="chatheder">
        <Header3 />
      </div>
      <div className="container bgcontrow scaloverallf mt-4">
        <div className="row bgcplorow">
          <div className="d-flex justify-content-center  justify-content-lg-start mb-5  gap-xl-5 gap-lg-3">
            <div
              className=" wchatname d-lg-block d-none pb-1 rounded-1 w-100"
              style={{
                backgroundColor: "#D9D9D952",
                maxWidth: "376px",
                height: "auto",
              }}
            >
              <div className="fw-bold pt-3 mx-3" style={{ fontSize: "30px" }}>
                Messages
              </div>

              <div>
                {chats?.map((msg) => {
                  let opositeUser =
                    msg.user._id === userData.user._id
                      ? msg.ambassador
                      : msg.user;
                  return (
                    <div
                      className={` list-group w-100 my-3 wchatname rounded-0 ${
                        selectedUser && selectedUser._id === msg._id
                          ? "bg-highlight"
                          : ""
                      }`}
                      style={{
                        maxWidth: "377px",
                        height: "83px",
                        backgroundColor:
                          selectedUser && selectedUser._id === msg._id
                            ? "#D0CECE"
                            : "transparent",
                      }}
                    >
                      <div
                        key={msg.id}
                        className={`list-group-item bg-transparent border-0 d-flex justify-content-between align-items-start"
                    selectedUser && selectedUser._id === msg.id ? "bg-highlight" : ""
      }`}
                        onClick={() => {
                          handleUserClick(msg);
                          let user =
                            msg.user._id !== userData.user._id
                              ? msg.ambassador
                              : msg.user;
                          console.log(user, "ss");

                          setSelected(user);
                        }} // Set selected user on click
                        style={{ cursor: "pointer" }}
                      >
                        <div className="d-flex gap-3">
                          <img
                            src={require("./image/paulsmithf.png")}
                            width="66"
                            height="66"
                            onClick={(e) => {
                              e.stopPropagation(); // Prevent parent click event
                              navigate("/ambassadoruserprofile");
                            }}
                            style={{ cursor: "pointer" }}
                          />
                          <div>
                            <div className="fs-5 mt-2 fw-bold">
                              {opositeUser.name}
                            </div>
                            <small>{msg?.latestMessage?.content}</small>
                          </div>
                        </div>
                        <small className="mt-4 fw600 ">
                          {" "}
                          {msg?.latestMessage?.createdAt
                            ? moment(msg.latestMessage.createdAt).fromNow()
                            : ""}
                        </small>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            <div>
              {!isMobileDetailView && (
                <div
                  className=" mobilwchatname bgcolorcli d-lg-none d-block rounded-1 w-100"
                  style={{
                    backgroundColor: "#D9D9D952",
                    maxWidth: "376px",
                    height: "670px",
                  }}
                >
                  <div
                    className="fw-bold pt-3 ftzwork mx-3"
                    style={{ fontSize: "30px" }}
                  >
                    Messages
                  </div>
                  {/* User List - Display on Mobile only if not in Detail View */}
                  <div className="list-group  my-3  rounded-0 ">
                    {chats?.map((msg) => (
                      <div
                        key={msg._id}
                        className="list-group-item bg-transparent mobilwchatnameagg border-0 d-flex justify-content-between align-items-start"
                        onClick={() => {
                          handleUserClick(msg);
                          let user =
                            msg.user._id !== userData.user._id
                              ? msg.ambassador
                              : msg.user;
                          console.log(user, "ss");

                          setSelected(user);
                        }} // Set selected user on click
                        style={{ cursor: "pointer" }}
                      >
                        <div className="d-flex gap-3">
                          <img
                            src={require("./image/paulsmithf.png")}
                            width="66"
                            height="66"
                            className="msgimgch"
                            onClick={(e) => {
                              e.stopPropagation(); // Prevent parent click event
                              navigate("/ambassadoruserprofile");
                            }}
                          />
                          <div>
                            <div className="fs-5 mt-2 ftlink fw-bold">
                              {msg.name}
                            </div>
                            <small>{msg.message}</small>
                          </div>
                        </div>
                        <small className="mt-4 fw600 ">{msg.timeAgo}</small>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <div>
              {/* Message Box (Chat Details) */}
              {selectedUser && (
                <div
                  className=" masboxmw d-lg-block d-none pb-1 rounded-1 w-100 "
                  style={{
                    maxWidth: "855px",
                    height: "auto",
                    backgroundColor: "#D9D9D952",
                  }}
                >
                  <div className="d-flex justify-content-between mx-2">
                    <div className="d-flex gap-1 pt-3 px-4">
                      <div>
                        <img
                          src={require("./image/paulsmithf.png")}
                          width="47"
                          height="47"
                          onClick={(e) => {
                            e.stopPropagation(); // Prevent parent click event
                            navigate("/ambassadoruserprofile");
                          }}
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                      <div>
                        <div className="fw-bold fs-6 mt-1">
                          {selected?.name}
                        </div>

                        <small
                          className="text-muted d-flex gap-1 "
                          style={{ fontSize: "12px" }}
                        >
                          <img
                            src={require("../pages/image/locchat.png")}
                            alt="loc"
                            width="12"
                            height="12"
                            className="mt-1"
                          />
                          London, UK
                        </small>
                      </div>
                    </div>

                    <div className="px-2" style={{ cursor: "pointer" }}>
                      <Dropdown>
                        <Dropdown.Toggle as="div">
                          <img
                            src={require("./image/dot3.png")}
                            alt="dot"
                            className="mt-4 pt-3 mx-sm-4 mx-2"
                            style={{ display: "inline-block" }}
                          />
                        </Dropdown.Toggle>
                        <div className="dropchat">
                          <Dropdown.Menu className="py-2 px-1  ">
                            <Dropdown.Item
                              className="fs-6 mt-1 fw600 text-dark"
                              style={{ lineHeight: "21.79px" }}
                              onClick={() => navigate("/ambassadoruserprofile")}
                            >
                              View Profile
                            </Dropdown.Item>
                            <Dropdown.Item
                              className="fs-6 mt-1 fw600 text-dark"
                              style={{ lineHeight: "21.79px" }}
                            >
                              Mute
                            </Dropdown.Item>
                            <Dropdown.Item
                              className="fs-6 mt-1 fw600 text-dark"
                              style={{ lineHeight: "21.79px" }}
                            >
                              Block
                            </Dropdown.Item>
                            <Dropdown.Item
                              className="fs-6 mt-1 fw600 text-dark"
                              style={{ lineHeight: "21.79px" }}
                            >
                              Report
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </div>
                      </Dropdown>
                    </div>
                  </div>

                  <div
                    className=" w-100 mt-3 "
                    style={{
                      maxWidth: "854px ",
                      height: "1px",
                      border: "1px solid black",
                    }}
                  ></div>
                  <div className="mt-3">
                    {selectedUser?.details?.map((detail, index) => (
                      <div
                        key={index}
                        className="d-flex gap-3 mb-3 px-4 mx-2 pt-3"
                      >
                        <div className="me-2">
                          <img
                            src={require("./image/paulsmithf.png")}
                            alt="profile"
                            className="rounded-circle"
                            width="41"
                            height="41"
                          />
                        </div>
                        <div
                          className="p-2 rounded-4 w-100"
                          style={{
                            backgroundColor: "#DEDEDE",
                            maxWidth: "772px",
                            height: "116px",
                          }}
                        >
                          <div className="d-flex justify-content-between">
                            <div
                              className="mb-0 w-100 fw-normal fs-16 px-3 py-1"
                              style={{ maxWidth: "722px" }}
                            >
                              {detail.text}
                            </div>
                            <small className=" mx-4 pt-5 mt-4 fw600">
                              {detail.time}
                            </small>
                          </div>
                        </div>
                      </div>
                    ))}

                    <div>
                      <small className="text-center d-flex justify-content-center  fw600 mt-3">
                        November 12, 2024
                      </small>
                      <div className="mt-3">
                        {messages?.map((detail, index) => (
                          <div
                            key={index}
                            className="d-flex gap-3 mb-3 px-4 mx-2 pt-3"
                          >
                            <div className="me-2">
                              <img
                                src={require("./image/paulsmithf.png")}
                                alt="profile"
                                className="rounded-circle"
                                width="41"
                                height="41"
                              />
                            </div>
                            <div
                              className="p-2 rounded-4 w-100"
                              style={{
                                backgroundColor: "#DEDEDE",
                                maxWidth: "772px",
                                height: "116px",
                              }}
                            >
                              <div className="d-flex justify-content-between">
                                <div
                                  className="mb-0 w-100 fw-normal fs-16 px-3 py-1"
                                  style={{ maxWidth: "722px" }}
                                >
                                  {detail?.content}
                                </div>
                                <small className=" mx-4 pt-5 mt-4 fw600">
                                  {detail?.createdAt
                                    ? moment(detail.createdAt).format(
                                        "h:mm:ss a"
                                      ) // or use date-fns or JavaScript's Date object
                                    : "No time available"}
                                </small>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div
                      className="d-flex bg-white mx-3 sendwidlg  w-100 mb-5 mt-4 rounded-1"
                      style={{
                        height: "40",
                        maxWidth: "740px ",
                        border: "1px solid #868686",
                        position: "relative",
                      }}
                    >
                      <div
                        className="w-100 my-1 mx-1 position-absolute"
                        style={{
                          backgroundColor: "unset",
                          maxWidth: "33px",
                          // height: "33px",
                          // right: "1px",

                          bottom: message ? "10px" : "50%", // Moves up when typing
                          transform: message
                            ? "translateY(5px)"
                            : "translateY(50%)",
                          // transition: "0.2s ease",
                        }}
                      >
                        <img
                          src={require("./image/chatemj.png")}
                          width="24"
                          height="24"
                          className="mx-2 mt-2"
                        />
                      </div>
                      <textarea
                        ref={textareaRef}
                        className="form-control border-0 fs-5 rounded-0 placeholder-login"
                        id="text"
                        value={message}
                        onChange={handleInputChange}
                        // placeholder="Type a message"
                        style={{
                          resize: "none",
                          overflow: "hidden",
                          height: "40px",
                          minHeight: "40px", // Fixed minimum height
                          maxHeight: "150px", // Expands up to 150px
                          flexGrow: 1,
                          paddingLeft: "50px",
                          paddingRight: "45px", // Ensure text doesn’t overlap with send icon
                        }}
                      />
                      {/* <input
                        type="text"
                        className="form-control border-0 fs-5 rounded-0 placeholder-login"
                        id="text"
                      /> */}
                      <div
                        className="w-100 my-1 mx-1 position-absolute"
                        style={{
                          backgroundColor: "#CDCDCD",
                          maxWidth: "33px",
                          height: "33px",
                          right: "1px",

                          bottom: message ? "0px" : "40%", // Moves up when typing
                          transform: message
                            ? "translateY(0)"
                            : "translateY(50%)",
                          transition: "0.2s ease",
                        }}
                      >
                        <img
                          src={require("./image/sendmsgicon.png")}
                          className="px-2 py-2"
                          onClick={() => {
                            // Send message
                            alert("Sending message:", message);
                            socket.emit("send_message", {
                              senderId: userData?.user?._id,
                              receiverId:
                                selectedUser._id === userData.user._id
                                  ? selectedUser.ambassador._id
                                  : selectedUser.user._id,
                              chatId: selectedUser._id,
                              message,
                            });
                            setMessages([...messages, message]);
                            console.log("Sending message:", message);
                            setMessage(""); // Clear message input
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="">
              {isMobileDetailView && selectedUser && (
                <div
                  className=" masboxmw d-block bgnoneunset pb-1 d-lg-none rounded-1 w-100 "
                  style={{
                    maxWidth: "855px",
                    height: "auto ",
                    backgroundColor: "#D9D9D952",
                  }}
                >
                  <div className="d-flex justify-content-between mx-2">
                    <div className="d-flex gap-sm-3 gap-1 pt-3 px-sm-3">
                      {/* Go Back Button */}
                      <div onClick={handleGoBack} className="back-arrow  my-2">
                        <ArrowLeft size={24} />{" "}
                        {/* This will render an arrow icon */}
                      </div>
                      {/* <button
                        onClick={handleGoBack}
                        className="btn btn-secondary mb-3"
                      >
                        Go Back
                      </button> */}
                      <div>
                        <img
                          src={require("./image/paulsmithf.png")}
                          width="47"
                          height="47"
                          className="detimgzch"
                          onClick={(e) => {
                            e.stopPropagation(); // Prevent parent click event
                            navigate("/ambassadoruserprofile");
                          }}
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                      <div>
                        <div className="fw-bold fontmobil fs-6 mt-md-1">
                          {messages[0]?.name}
                        </div>

                        <small
                          className="text-muted d-flex gap-1 "
                          style={{ fontSize: "12px" }}
                        >
                          <img
                            src={require("../pages/image/locchat.png")}
                            alt="loc"
                            width="12"
                            height="12"
                            className="mt-1"
                          />
                          London, UK
                        </small>
                      </div>
                    </div>

                    <div className="px-2" style={{ cursor: "pointer" }}>
                      <Dropdown>
                        <Dropdown.Toggle as="div">
                          <img
                            src={require("./image/dot3.png")}
                            alt="dot"
                            className="mt-4 pt-3 mx-sm-4 mx-2 widot"
                            style={{ display: "inline-block" }}
                          />
                        </Dropdown.Toggle>
                        <div className="  dropchatmob">
                          <Dropdown.Menu className="py-2 px-1">
                            <Dropdown.Item
                              className="fs-6 mt-1 fw600 text-dark"
                              style={{ lineHeight: "21.79px" }}
                              onClick={() => navigate("/ambassadoruserprofile")}
                            >
                              View Profile
                            </Dropdown.Item>
                            <Dropdown.Item
                              className="fs-6 mt-1 fw600 text-dark"
                              style={{ lineHeight: "21.79px" }}
                            >
                              Mute
                            </Dropdown.Item>
                            <Dropdown.Item
                              className="fs-6 mt-1 fw600 text-dark"
                              style={{ lineHeight: "21.79px" }}
                            >
                              Block
                            </Dropdown.Item>
                            <Dropdown.Item
                              className="fs-6 mt-1 fw600 text-dark"
                              style={{ lineHeight: "21.79px" }}
                            >
                              Report
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </div>
                      </Dropdown>
                    </div>
                  </div>

                  <div
                    className=" w-100 mt-3 "
                    style={{
                      maxWidth: "854px ",
                      height: "1px",
                      border: "1px solid black",
                    }}
                  ></div>

                  {/* Message Box (Chat Details) - Show on Mobile when in Detail View */}
                  <div className="mt-3">
                    {selectedUser?.details?.map((detail, index) => (
                      <div
                        key={index}
                        className="d-flex gap-sm-3 gap-1 mb-3 px-sm-4 mx-sm-2 pt-3"
                      >
                        <div className="padsm me-2">
                          <img
                            src={require("./image/paulsmithf.png")}
                            alt="profile"
                            className="rounded-circle"
                            width="41"
                            height="41"
                          />
                        </div>
                        <div
                          className="p-2 rounded-4 w-100"
                          style={{
                            backgroundColor: "#DEDEDE",
                            maxWidth: "772px",
                            height: "116px",
                          }}
                        >
                          <div className="d-flex justify-content-between">
                            <div
                              className="mb-0 w-100 fontmobil fw-normal fs-6 px-sm-3 py-sm-1"
                              style={{ maxWidth: "722px" }}
                            >
                              {detail.text}
                            </div>
                            <small className=" mx-sm-4 pt-5 mt-4 fw600">
                              {detail.time}
                            </small>
                          </div>
                        </div>
                      </div>
                    ))}

                    <div>
                      <small className="text-center d-flex justify-content-center  fw600 mt-3">
                        November 12, 2024
                      </small>
                      <div className="mt-3">
                        {novmsg[0].details.map((detail, index) => (
                          <div
                            key={index}
                            className="d-flex gap-sm-3 gap-1 mb-3 px-sm-4 mx-sm-2 pt-3"
                          >
                            <div className="me-2">
                              <img
                                src={require("./image/paulsmithf.png")}
                                alt="profile"
                                className="rounded-circle"
                                width="41"
                                height="41"
                              />
                            </div>
                            <div
                              className="p-2 rounded-4 w-100"
                              style={{
                                backgroundColor: "#DEDEDE",
                                maxWidth: "772px",
                                height: "116px",
                              }}
                            >
                              <div className="d-flex justify-content-between">
                                <div
                                  className="mb-0 w-100 fw-normal fs-16 px-sm-3 py-sm-1"
                                  style={{ maxWidth: "722px" }}
                                >
                                  {detail.text}
                                </div>
                                <small className=" mx-sm-4 pt-5 mt-4 fw600">
                                  {detail.time}
                                </small>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div
                      className="d-none align-items-end bg-white mx-sm-3 mx-auto sendwidmobli w-100 mb-5 mt-4 rounded-1"
                      style={{
                        maxWidth: "660px",
                        border: "1px solid #868686",
                        padding: "5px",
                      }}
                    >
                      <img
                        src={require("./image/chatemj.png")}
                        width="24"
                        height="24"
                        className="mx-2"
                      />

                      <textarea
                        ref={textareaRef}
                        className="form-control border-0 fs-5 rounded-0 placeholder-login"
                        id="text"
                        value={message}
                        onChange={handleInputChange}
                        placeholder="Type a message"
                        style={{
                          resize: "none",
                          overflow: "hidden",
                          height: "40px",
                          minHeight: "40px", // Fixed minimum height
                          maxHeight: "150px", // Expands up to 150px
                          flexGrow: 1,
                          paddingRight: "40px", // Ensure text doesn’t overlap with send icon
                        }}
                      />

                      <div
                        className="position-absolute"
                        style={{
                          right: "15px",
                          bottom: message ? "10px" : "50%", // Moves up when typing
                          transform: message
                            ? "translateY(0)"
                            : "translateY(50%)",
                          transition: "0.2s ease",
                        }}
                      >
                        <img
                          src={require("./image/sendmsgicon.png")}
                          width="33"
                          height="33"
                          className="px-2 py-2"
                          alt="send"
                        />
                      </div>
                    </div>

                    <div
                      className="d-flex bg-white mx-sm-3 mx-auto sendwidmobli  w-100 mb-5 mt-4 rounded-1"
                      style={{
                        height: "40",
                        maxWidth: "660px ",
                        border: "1px solid #868686",
                        position: "relative",
                      }}
                    >
                      <div
                        className="w-100 my-1 mx-1 position-absolute"
                        style={{
                          backgroundColor: "unset",
                          maxWidth: "33px",
                          // height: "33px",
                          // right: "1px",

                          bottom: message ? "10px" : "50%", // Moves up when typing
                          transform: message
                            ? "translateY(5px)"
                            : "translateY(50%)",
                          // transition: "0.2s ease",
                        }}
                      >
                        <img
                          src={require("./image/chatemj.png")}
                          width="24"
                          height="24"
                          className="mx-2 mt-2"
                        />
                      </div>
                      <textarea
                        ref={textareaRef}
                        className="form-control border-0 fs-5 rounded-0 placeholder-login"
                        id="text"
                        value={message}
                        onChange={handleInputChange}
                        // placeholder="Type a message"
                        style={{
                          resize: "none",
                          overflow: "hidden",
                          height: "40px",
                          minHeight: "40px", // Fixed minimum height
                          maxHeight: "150px", // Expands up to 150px
                          flexGrow: 1,
                          paddingLeft: "50px",
                          paddingRight: "45px", // Ensure text doesn’t overlap with send icon
                        }}
                      />

                      {/* <input
                        type="text"
                        className="form-control border-0 fs-5 rounded-0 placeholder-login"
                        id="text"
                      /> */}
                      <div
                        className="w-100 my-1 mx-1 position-absolute"
                        style={{
                          backgroundColor: "#CDCDCD",
                          maxWidth: "33px",
                          height: "33px",
                          right: "1px",

                          bottom: message ? "0px" : "40%", // Moves up when typing
                          transform: message
                            ? "translateY(0)"
                            : "translateY(50%)",
                          transition: "0.2s ease",
                        }}
                      >
                        <img
                          src={require("./image/sendmsgicon.png")}
                          className="px-2 py-2"
                          style={{ cursor: "pointer", zIndex: "1000" }}
                          onClick={() => {
                            // Send message
                            if (message) {
                              alert("Sending message:", message);
                              socket.emit("send_message", {
                                senderId: userData?.user?._id,
                                receiverId: "67704a195fafc6e44513d329",
                                chatId: "67ddd46020157ab43ddfa0c3",
                                message,
                              });
                              console.log("Sending message:", message);
                              setMessage(""); // Clear message input
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChatBox;
